import React from "react";
import "./announcementBar.scss";

export default function AnnouncementBar({ feature ,onViewClick,onLaterClick }) {
  return (
    <div className="row announcement-bar px-2 py-3">
      <div className="col-md-9 col-sm-12">
        <div className="announcement-title">{feature?.banner_title}</div>
        <div className="announcement-message">{feature?.banner_details}</div>
      </div>
      <div className="col-md-3 col-sm-12 action-btn">
        <div>
          <button className="view-btn px-4 py-2" onClick={()=> onViewClick(feature?.feature_id)}>View</button>
        </div>
        <div>
          <button className="maybe-later-btn" onClick={() => onLaterClick(feature?.feature_id)}>Maybe later</button>
        </div>
      </div>
    </div>
  );
}
